"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
var request_1 = require("./request");
var createClient = function (url, opts) {
    return new request_1.GraphQLClient(url, opts);
};
exports.createClient = createClient;
//# sourceMappingURL=client.js.map